import { SEmptyView } from './EmptyView.styles';
import { EmptyViewProps } from './EmptyView.types';

export const EmptyView = ({ ...props }: EmptyViewProps) => {
  return <SEmptyView {...props} />;
};
